import { render, staticRenderFns } from "./ActionList.vue?vue&type=template&id=64688806&scoped=true"
import script from "./ActionList.vue?vue&type=script&lang=js"
export * from "./ActionList.vue?vue&type=script&lang=js"
import style0 from "./ActionList.vue?vue&type=style&index=0&id=64688806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64688806",
  null
  
)

export default component.exports